import { render, staticRenderFns } from "./GenericAnimation.vue?vue&type=template&id=48195920&"
import script from "./GenericAnimation.vue?vue&type=script&lang=js&"
export * from "./GenericAnimation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports